export default __webpack_public_path__ + "static/poster-b39105bad6fe914ee0c964dfcbccf045.jpg";